import React from 'react'
import { RingLoader } from 'react-spinners'

const Loader = () => {
  return (
    <>
            
            <div className="loder">
            <RingLoader color="#9290C3" />

            </div>
    </>
  )
}

export default Loader
